import { apiClient, bearer, unwrap } from './client';
import type { components } from './types';

export type EngagementNoteOut = components['schemas']['EngagementNoteOut'];
export type EngagementNoteListOut = components['schemas']['EngagementNoteListOut'];

export function listPortalNotes(
  engagementId: string,
  idToken: string,
): Promise<EngagementNoteListOut> {
  return apiClient
    .GET('/api/portal/engagements/{engagement_id}/notes', {
      params: { path: { engagement_id: engagementId } },
      headers: bearer(idToken),
    })
    .then(unwrap<EngagementNoteListOut>);
}

export function createPortalNote(
  engagementId: string,
  body: string,
  idToken: string,
): Promise<EngagementNoteOut> {
  return apiClient
    .POST('/api/portal/engagements/{engagement_id}/notes', {
      params: { path: { engagement_id: engagementId } },
      body: { body },
      headers: bearer(idToken),
    })
    .then(unwrap<EngagementNoteOut>);
}
